import { UrlParams } from "search-params";
import { State } from "store/store-types";

export const getStateFromParams = (params: UrlParams, previousState: State): State => {
    const newState: State = { ...previousState };

    newState.guests = params.guests ?? undefined;
    newState.guestsChildren = params.guestsChildren ?? undefined;
    newState.date = params.date || undefined;

    return newState;
};
